module.exports = {
    isLoggedIn: () => document.body.classList.contains('is-logged-in')
};
